// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gc-agency-name {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #1F2937;
}

p.gc-agency-handle {
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5);
}

.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.gc-agency-img {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gc-agency-img img {
  min-width: 100%;
}

.icon-badge-gold:before {
  content: "\\e900";
  color: #f2c94c;
}

.gc-pr-12 {
  padding-right: 12px !important;
}

.gc-pl-12 {
  padding-left: 12px !important;
}

.custom-invalid {
  border: 1px solid red !important;
}

.validation-text {
  display: block;
  margin-top: 5px;
  color: red;
}

.max-img-note {
  font-size: 12px;
  margin: 8px 0 20px 0;
}

.table-header > div:first-child {
  flex: 1 1 0;
  min-width: min-content;
}
.table-header > div:first-child .user-label {
  min-width: max-content;
}
.table-header h2 {
  line-height: 1;
}
.table-header .table-search-wrapper {
  max-width: 452px;
  flex: 1 1 auto;
  margin: 0;
}
.table-header .table-calendar-wrapper,
.table-header .field,
.table-header .export-btn,
.table-header p-button {
  margin: 0;
}
.table-header .field {
  margin-bottom: 0 !important;
}
@media (max-width: 1200px) {
  .table-header {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .table-header .table-search-wrapper {
    max-width: 100%;
    width: 100%;
  }
}

.bulkUpload-btn-company {
  flex: 0 0 162px;
}

.asso-container {
  max-height: 315px;
  overflow: auto;
}

.bulkUpload-btn-company {
  flex: 0 0 162px;
}

.asso-container {
  max-height: 315px;
  overflow: auto;
}

.text-center {
  text-align: center;
  width: 100%;
}

.associated-agencies:hover {
  background: #F6F8FF;
}

.associated-agencies-parent > :last-child {
  border-radius: 0 0 10px 10px;
}

::ng-deep .app-link-dropdown.p-dropdown {
  display: flex !important;
  align-items: center !important;
}
::ng-deep .app-link-dropdown.p-dropdown .p-dropdown-label {
  display: flex !important;
  align-items: center !important;
  padding: 0 12px !important;
  line-height: normal !important;
  height: 100% !important;
}

:host ::ng-deep .export-report .p-dropdown .p-dropdown-label {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

:host ::ng-deep .export-report .p-dropdown .p-dropdown-label {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

:host ::ng-deep .export-report .p-dropdown .p-dropdown-trigger {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
